import { render, staticRenderFns } from "./architect.vue?vue&type=template&id=ce96e004&"
import script from "./architect.vue?vue&type=script&lang=js&"
export * from "./architect.vue?vue&type=script&lang=js&"
import style0 from "./architect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports